import Swiper, { Pagination, Autoplay } from 'swiper';
Swiper.use([Pagination, Autoplay]);
import * as balanceText from 'Lib/balanceText.js';

export namespace Testimonial {
	let setupTestimonials = () => {

		let testimonials = document.querySelectorAll('.testimonial');

		//For Each Hero Slider Loop through and setup swiper
		testimonials.forEach((testimonial, index) => {
			testimonial.classList.add(`testimonial--${index}`);
			let swiperSlides = testimonial.querySelectorAll('.swiper-slide');

			if(testimonial.classList.contains('testimonial--list')) {
				const swiper = new Swiper(`.testimonial--${index}`, {
					slidesPerView: 1,

					// If we need pagination
					pagination: {
						el: `.testimonial--${index} .swiper-pagination`,
						clickable: true
					},
					on: {
						init: function () {
							balanceText();
						},
					}
				});
			}
		});
	}

	export const init = () => {
		setupTestimonials();
	}
}


document.addEventListener('DOMContentLoaded', Testimonial.init);
